// extracted by mini-css-extract-plugin
export var brand = "_bm-9";
export var compact = "_bm-6";
export var extraSmall = "_bm-7";
export var icon = "_bm-0";
export var large = "_bm-4";
export var light = "_bm-1";
export var medium = "_bm-5";
export var outline = "_bm-b";
export var primaryDark = "_bm-a";
export var primaryLight = "_bm-8";
export var primaryModern = "_bm-c";
export var success = "_bm-2";
export var successSolid = "_bm-3";